import { saveAs } from "file-saver";

export const downloadRoadmapCallsExcel = async (api, { filters, epoll }) => {
  const filename = `گزارش تماس نقشه راه‌ها - ${epoll ? "ایپل" : "پلنیوم"}.xlsx`;
  const { data, status } = await api.get("/roadmaps/export-calls-excel", {
    params: { ...filters, epoll },
    responseType: "blob",
  });
  if (status === 204) return false;
  saveAs(data, filename);
  return true;
};
